import { LitElement, html, css, PropertyValues } from 'lit';
import { customElement, property, state, query } from 'lit/decorators.js';
import { ClubSearchResult, CitySearchResult, PadelClubAutocompleteOptions } from '../../types/padel-club.js';

// SVG Icons as template literals for Shadow DOM compatibility
const icons = {
  mapMarker: html`<svg width="16" height="16" viewBox="0 0 384 512" fill="currentColor"><path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"/></svg>`,
  externalLink: html`<svg width="16" height="16" viewBox="0 0 512 512" fill="currentColor"><path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"/></svg>`,
  mapMarkedAlt: html`<svg width="16" height="16" viewBox="0 0 576 512" fill="currentColor"><path d="M408 120c0 54.6-73.1 151.9-105.2 192-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503V200.4zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/></svg>`,
  spinner: html`<svg width="16" height="16" viewBox="0 0 512 512" fill="currentColor" class="fa-spin"><path d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"/></svg>`,
  search: html`<svg width="16" height="16" viewBox="0 0 512 512" fill="currentColor"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>`,
  edit: html`<svg width="16" height="16" viewBox="0 0 512 512" fill="currentColor"><path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"/></svg>`,
  city: html`<svg width="16" height="16" viewBox="0 0 640 512" fill="currentColor"><path d="M480 48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48V96H224V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V96H112V24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H256V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96H592c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H480V48zM64 232c0-13.3 10.7-24 24-24s24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V232zm0 112c0-13.3 10.7-24 24-24s24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V344zm144-112c0-13.3 10.7-24 24-24s24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V232zm0 112c0-13.3 10.7-24 24-24s24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V344zm144-112c0-13.3 10.7-24 24-24s24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V232zm0 112c0-13.3 10.7-24 24-24s24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V344zm144-112c0-13.3 10.7-24 24-24s24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V232zm0 112c0-13.3 10.7-24 24-24s24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V344z"/></svg>`
};

@customElement('pm-padel-club-autocomplete')
export class PmPadelClubAutocomplete extends LitElement {
  static styles = css`
    :host {
      position: relative;
      display: block;
      width: 100%;
    }

    /* SVG Icon styles and animations */
    svg {
      display: inline-block;
      vertical-align: middle;
      width: 16px;
      height: 16px;
    }

    .fa-spin {
      animation: fa-spin 2s infinite linear;
    }

    @keyframes fa-spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    .club-action-btn svg,
    .selected-club-btn svg {
      width: 14px;
      height: 14px;
    }

    .manual-input-btn svg {
      margin-right: 6px;
    }

    .loading svg {
      margin-right: 8px;
    }

    .no-results svg {
      margin-right: 8px;
    }

    .padel-club-dropdown {
      position: fixed;
      background: var(--bs-body-bg, white);
      border: 1px solid var(--bs-border-color, #ddd);
      border-radius: 8px;
      box-        const manualText = prompt('Inserisci manualmente il nome del club:');hadow: 0 8px 16px rgba(0,0,0,0.15);
      max-height: 400px;
      overflow-y: auto;
      z-index: 9999;
      display: none;
      min-width: 300px;
      transition: opacity 0.2s ease;
      opacity: 0;
    }
    
    .padel-club-dropdown.show {
      display: block;
      opacity: 1;
    }



    .padel-result-item {
      padding: 12px 16px;
      cursor: pointer;
      border-bottom: 1px solid var(--bs-border-color, #f0f0f0);
      transition: background-color 0.2s ease;
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .padel-result-item:hover,
    .padel-result-item.selected {
      background-color: var(--bs-primary-bg-subtle, #e3f2fd);
    }

    .padel-result-item:last-child {
      border-bottom: none;
    }

    .club-icon {
      width: 40px;
      height: 40px;
      background: var(--bs-primary, #007bff);
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      flex-shrink: 0;
    }

    .club-info {
      flex: 1;
      min-width: 0;
    }

    .club-name {
      font-weight: 600;
      color: var(--bs-body-color);
      margin: 0 0 4px 0;
      font-size: 14px;
    }

    .club-details {
      color: var(--bs-text-muted, #6c757d);
      font-size: 12px;
      margin: 0;
    }

    .club-actions {
      display: flex;
      gap: 8px;
      flex-shrink: 0;
    }

    .club-action-btn {
      padding: 6px 8px;
      border: 1px solid var(--bs-border-color);
      border-radius: 4px;
      font-size: 12px;
      text-decoration: none;
      color: var(--bs-primary);
      background: var(--bs-body-bg);
      cursor: pointer;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 32px;
      min-height: 32px;
    }

    .club-action-btn:hover {
      background-color: var(--bs-primary);
      color: white;
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }

    .club-action-btn i {
      font-size: 14px;
    }

    .no-results {
      padding: 20px;
      text-align: center;
      color: var(--bs-text-muted);
      font-style: italic;
    }

    .loading {
      padding: 20px;
      text-align: center;
      color: var(--bs-text-muted);
    }

    .manual-input-section {
      padding: 16px;
      border-top: 2px solid var(--bs-border-color);
      background-color: var(--bs-secondary-bg, #f8f9fa);
    }

    .manual-input-title {
      font-weight: 600;
      margin-bottom: 8px;
      font-size: 13px;
      color: var(--bs-body-color);
    }

    .manual-input-btn {
      width: 100%;
      padding: 10px 12px;
      border: 1px dashed var(--bs-border-color);
      background: transparent;
      color: var(--bs-text-muted);
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
    }

    .manual-input-btn:hover {
      border-color: var(--bs-primary);
      color: var(--bs-primary);
      background: var(--bs-primary-bg-subtle, rgba(13, 110, 253, 0.1));
    }

    .manual-input-btn i {
      font-size: 14px;
    }

    .selected-club-info {
      margin-top: 0.5rem;
      display: none;
    }

    .selected-club-info.show {
      display: block;
    }

    .selected-club-card {
      background: var(--bs-success-bg-subtle, #d1e7dd);
      border: 1px solid var(--bs-success-border-subtle, #badbcc);
      border-radius: 0.375rem;
      padding: 0.75rem;
      display: flex;
      align-items: center;
      gap: 0.75rem;
    }

    .selected-club-details {
      flex: 1;
      min-width: 0;
    }

    .selected-club-name {
      font-weight: 600;
      color: var(--bs-success-text-emphasis, #0f5132);
      margin: 0 0 0.25rem 0;
      font-size: 0.875rem;
    }

    .selected-club-address {
      color: var(--bs-text-muted, #6c757d);
      font-size: 0.75rem;
      margin: 0;
    }

    .selected-club-actions {
      display: flex;
      gap: 0.5rem;
      flex-shrink: 0;
    }

    .selected-club-btn {
      padding: 0.25rem 0.5rem;
      border: 1px solid;
      border-radius: 0.25rem;
      font-size: 0.75rem;
      text-decoration: none;
      cursor: pointer;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      gap: 0.25rem;
    }

    .selected-club-btn.btn-map {
      background: #4285f4;
      color: white;
      border-color: #4285f4;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .selected-club-btn.btn-map:hover {
      background: #3367d6;
      color: white;
      border-color: #3367d6;
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(66, 133, 244, 0.3);
    }

    .selected-club-btn.btn-change {
      color: var(--bs-secondary);
      border-color: var(--bs-secondary);
      background: transparent;
    }

    .selected-club-btn.btn-change:hover {
      background: var(--bs-secondary);
      color: white;
    }

    @media (max-width: 576px) {
      .club-actions {
        flex-direction: column;
        gap: 4px;
      }
      
      .club-action-btn {
        font-size: 10px;
        padding: 2px 6px;
      }

      .selected-club-actions {
        flex-direction: column;
        gap: 0.25rem;
      }

      .selected-club-btn {
        font-size: 0.7rem;
        padding: 0.2rem 0.4rem;
      }
    }
  `;

  @property({ type: String }) selector = '';
  @property({ type: Number, attribute: 'min-chars' }) minChars = 2;
  @property({ type: Number, attribute: 'max-results' }) maxResults = 10;
  @property({ type: Number, attribute: 'debounce-ms' }) debounceMs = 300;
  @property({ type: Boolean, attribute: 'show-map-links' }) showMapLinks = true;
  @property({ type: Boolean, attribute: 'show-manual-input' }) showManualInput = true;
  @property({ type: String }) placeholder = 'Cerca padel club...';
  @property({ type: String, attribute: 'no-results-text' }) noResultsText = 'Nessun club trovato';
  @property({ type: String, attribute: 'api-base-url' }) apiBaseUrl = '/clubs/api/';

  @state() private isOpen = false;
  @state() private selectedIndex = -1;
  @state() private results: (ClubSearchResult | CitySearchResult)[] = [];
  @state() private currentQuery = '';
  @state() private isLoading = false;
  @state() private selectedClub: ClubSearchResult | null = null;
  @state() private showSelectedClub = false;

  private debounceTimer: number | null = null;
  private inputElement: HTMLInputElement | null = null;

  @query('.padel-club-dropdown') private dropdown!: HTMLDivElement;

  connectedCallback(): void {
    super.connectedCallback();
    this.setupInputElement();
  }

  firstUpdated(): void {
    // Ensure dropdown is available after first render
    if (this.dropdown && this.inputElement) {
      console.log('✅ PM-PadelClubAutocomplete ready:', {
        input: this.inputElement.id,
        dropdown: this.dropdown,
        selector: this.selector
      });
      
      // Check if there's already a selected club (edit mode)
      this.checkPreselectedClub();
    } else {
      console.warn('⚠️ PM-PadelClubAutocomplete missing elements:', {
        hasDropdown: !!this.dropdown,
        hasInput: !!this.inputElement,
        selector: this.selector
      });
    }
  }

  private checkPreselectedClub(): void {
    if (!this.inputElement) return;

    const clubId = this.inputElement.dataset.clubId;
    const clubName = this.inputElement.dataset.clubName;
    const clubCity = this.inputElement.dataset.clubCity;
    
    // Check if we have club data in dataset or if input has value that looks like a club
    if (clubId && clubName && clubCity) {
      // We have full club data in dataset
      const club: ClubSearchResult = {
        type: 'club',
        id: parseInt(clubId),
        name: clubName,
        city: clubCity
      };
      
      // Add optional properties only if they exist
      if (this.inputElement.dataset.clubAddress) {
        club.address = this.inputElement.dataset.clubAddress;
      }
      if (this.inputElement.dataset.clubPhone) {
        club.phone = this.inputElement.dataset.clubPhone;
      }
      if (this.inputElement.dataset.clubMapsUrl) {
        club.maps_url = this.inputElement.dataset.clubMapsUrl;
      }
      if (this.inputElement.dataset.clubWebsite) {
        club.website = this.inputElement.dataset.clubWebsite;
      }
      
      this.selectedClub = club;
      this.showSelectedClub = true;
    } else if (this.inputElement.value && this.inputElement.value.includes(',')) {
      // Input has value that looks like "Club Name, City" - treat as selected club
      const parts = this.inputElement.value.split(',').map(p => p.trim());
      if (parts.length >= 2) {
        this.selectedClub = {
          type: 'club',
          id: 0, // Unknown ID for manual entries
          name: parts[0],
          city: parts.slice(1).join(', ')
        };
        this.showSelectedClub = true;
      }
    }
  }

  private generateMapsUrl(club: ClubSearchResult): string {
    // Se il club ha già un maps_url, lo usa
    if (club.maps_url && club.maps_url.trim()) {
      return club.maps_url;
    }
    
    // Altrimenti genera l'URL di Google Maps dall'indirizzo
    const query = encodeURIComponent(`${club.name} ${club.address || ''} ${club.city || ''}`);
    return `https://www.google.com/maps/search/?api=1&query=${query}`;
  }



  disconnectedCallback(): void {
    super.disconnectedCallback();
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.removeEventListeners();
  }

  private setupInputElement(): void {
    if (this.selector) {
      this.inputElement = document.querySelector(this.selector) as HTMLInputElement;
    } else {
      // Find input element in parent
      this.inputElement = this.parentElement?.querySelector('input') as HTMLInputElement;
    }

    if (this.inputElement) {
      this.inputElement.setAttribute('autocomplete', 'off');
      this.inputElement.setAttribute('placeholder', this.placeholder);
      this.setupEventListeners();
    }
  }

  private setupEventListeners(): void {
    if (!this.inputElement) return;

    this.inputElement.addEventListener('input', this.handleInput.bind(this));
    this.inputElement.addEventListener('focus', this.handleFocus.bind(this));
    this.inputElement.addEventListener('keydown', this.handleKeydown.bind(this));
    this.inputElement.addEventListener('blur', this.handleBlur.bind(this));
    document.addEventListener('click', this.handleDocumentClick.bind(this));
    window.addEventListener('scroll', this.handleScroll.bind(this));
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  private removeEventListeners(): void {
    if (!this.inputElement) return;

    this.inputElement.removeEventListener('input', this.handleInput.bind(this));
    this.inputElement.removeEventListener('focus', this.handleFocus.bind(this));
    this.inputElement.removeEventListener('keydown', this.handleKeydown.bind(this));
    this.inputElement.removeEventListener('blur', this.handleBlur.bind(this));
    document.removeEventListener('click', this.handleDocumentClick.bind(this));
    window.removeEventListener('scroll', this.handleScroll.bind(this));
    window.removeEventListener('resize', this.handleResize.bind(this));
  }

  private handleScroll(): void {
    if (this.isOpen) {
      // Check if input is still visible in viewport
      if (this.inputElement) {
        const inputRect = this.inputElement.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        
        // If input scrolled out of view, close dropdown
        if (inputRect.bottom < 0 || inputRect.top > viewportHeight) {
          this.close();
          return;
        }
      }
      
      // Otherwise update position for viewport changes
      this.updatePosition();
    }
  }

  private handleResize(): void {
    if (this.isOpen) {
      this.updatePosition();
    }
  }

  private handleInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    const query = target.value.trim();
    
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    this.debounceTimer = window.setTimeout(() => {
      if (query.length >= this.minChars) {
        this.search(query);
      } else {
        this.close();
      }
    }, this.debounceMs);
  }

  private handleFocus(): void {
    if (this.currentQuery && this.results.length > 0) {
      this.open();
    }
  }

  private handleKeydown(event: KeyboardEvent): void {
    if (!this.isOpen) return;

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        this.selectNext();
        break;
      case 'ArrowUp':
        event.preventDefault();
        this.selectPrevious();
        break;
      case 'Enter':
        event.preventDefault();
        this.selectCurrent();
        break;
      case 'Escape':
        this.close();
        break;
    }
  }

  private handleBlur(event: FocusEvent): void {
    // Delay closing to allow clicks on dropdown items
    setTimeout(() => {
      if (!this.contains(event.relatedTarget as Node)) {
        this.close();
      }
    }, 150);
  }

  private handleDocumentClick(event: Event): void {
    if (!this.contains(event.target as Node) && !this.inputElement?.contains(event.target as Node)) {
      this.close();
    }
  }

  private async search(query: string): Promise<void> {
    this.currentQuery = query;
    this.isLoading = true;
    this.open();

    try {
      const response = await fetch(
        `${this.apiBaseUrl}suggestions/?q=${encodeURIComponent(query)}&limit=${this.maxResults}`,
        {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      this.results = data.results || [];
      this.selectedIndex = -1;
    } catch (error) {
      console.error('Errore durante la ricerca:', error);
      this.results = [];
    } finally {
      this.isLoading = false;
    }
  }

  private selectNext(): void {
    if (this.selectedIndex < this.results.length - 1) {
      this.selectedIndex++;
      this.scrollToSelected();
    }
  }

  private selectPrevious(): void {
    if (this.selectedIndex > 0) {
      this.selectedIndex--;
      this.scrollToSelected();
    }
  }

  private selectCurrent(): void {
    if (this.selectedIndex >= 0 && this.selectedIndex < this.results.length) {
      this.selectItem(this.results[this.selectedIndex]);
    }
  }

  private selectItem(item: ClubSearchResult | CitySearchResult): void {
    if (!this.inputElement) return;

    if (item.type === 'club') {
      const club = item as ClubSearchResult;
      this.inputElement.value = club.display_name || `${club.name}, ${club.city}`;
      this.inputElement.dataset.clubId = club.id.toString();
      this.inputElement.dataset.clubName = club.name;
      this.inputElement.dataset.clubCity = club.city;
      this.inputElement.dataset.clubAddress = club.address || '';
      
      // Add country if available
      if (club.country) {
        this.inputElement.dataset.clubCountry = club.country;
      }
      
      // Show selected club info
      this.selectedClub = club;
      this.showSelectedClub = true;
      
      // Emit custom event for compatibility
      this.inputElement.dispatchEvent(new CustomEvent('clubSelected', {
        detail: club,
        bubbles: true
      }));
      
      this.close();
      this.inputElement.focus();
    }
    // Removed city handling - we only show clubs now

    // Trigger change event for form validation
    this.inputElement.dispatchEvent(new Event('change', { bubbles: true }));
  }

  private scrollToSelected(): void {
    const selectedElement = this.dropdown?.querySelector(`[data-index="${this.selectedIndex}"]`) as HTMLElement;
    if (selectedElement) {
      selectedElement.scrollIntoView({ block: 'nearest' });
    }
  }

  private open(): void {
    this.isOpen = true;
    // Use requestAnimationFrame to ensure proper positioning after render
    requestAnimationFrame(() => {
      this.updatePosition();
    });
  }

  private updatePosition(): void {
    if (!this.inputElement || !this.dropdown) return;

    const inputRect = this.inputElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const dropdownHeight = Math.min(400, viewportHeight * 0.4); // Responsive height
    
    // For fixed positioning, use viewport coordinates (no scrollY/scrollX)
    let top = inputRect.bottom + 2; // 2px gap from input bottom
    let left = inputRect.left;
    
    // Check if dropdown would go below viewport
    if (inputRect.bottom + dropdownHeight > viewportHeight) {
      // Position above input instead
      top = inputRect.top - dropdownHeight - 2;
    }
    
    // Ensure dropdown doesn't go off-screen horizontally
    const dropdownWidth = Math.max(inputRect.width, 300);
    if (left + dropdownWidth > viewportWidth - 20) {
      left = viewportWidth - dropdownWidth - 20;
    }
    left = Math.max(left, 10); // 10px margin from left edge
    
    // Apply positioning with smooth transition
    this.dropdown.style.top = `${top}px`;
    this.dropdown.style.left = `${left}px`;
    this.dropdown.style.width = `${dropdownWidth}px`;
    this.dropdown.style.maxHeight = `${dropdownHeight}px`;
    
    // Debug logging
    console.log('🔧 Dropdown positioned (fixed):', { top, left, width: dropdownWidth, inputRect });
  }

  private close(): void {
    this.isOpen = false;
    this.selectedIndex = -1;
  }

  private handleItemClick(item: ClubSearchResult | CitySearchResult): void {
    this.selectItem(item);
  }

  private handleManualInput(): void {
    if (!this.inputElement) return;
    
    this.close();
    
    // Emit custom event for external handling
    this.inputElement.dispatchEvent(new CustomEvent('showManualInput', {
      bubbles: true
    }));
    
    // Fallback: simple prompt if no external handler
    setTimeout(() => {
      const manualText = prompt('Inserisci manualmente il nome del club o la città:');
      if (manualText && manualText.trim()) {
        this.inputElement!.value = manualText.trim();
        this.inputElement!.dataset.manualInput = 'true';
        
        // Hide selected club info for manual input
        this.selectedClub = null;
        this.showSelectedClub = false;
        
        this.inputElement!.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 100);
  }

  private handleChangeClub(): void {
    if (!this.inputElement) return;
    
    // Clear selected club info and show input field again
    this.selectedClub = null;
    this.showSelectedClub = false;
    this.inputElement.value = '';
    
    // Clear data attributes
    delete this.inputElement.dataset.clubId;
    delete this.inputElement.dataset.clubName;
    delete this.inputElement.dataset.clubCity;
    delete this.inputElement.dataset.clubCountry;
    delete this.inputElement.dataset.clubAddress;
    delete this.inputElement.dataset.cityName;
    delete this.inputElement.dataset.manualInput;
    
    // Focus the input for new search
    this.inputElement.focus();
  }

  private openGoogleMaps(address: string): void {
    const url = `https://www.google.com/maps/search/${encodeURIComponent(address)}`;
    window.open(url, '_blank');
  }

  private renderClubItem(club: ClubSearchResult, index: number) {
    const isSelected = index === this.selectedIndex;
    const displayName = club.display_name || club.name;
    const fullAddress = club.full_address || 
      `${club.address ? club.address + ', ' : ''}${club.city}`;
    
    return html`
      <div 
        class="padel-result-item ${isSelected ? 'selected' : ''}"
        data-index="${index}"
        @click="${() => this.handleItemClick(club)}"
      >
        <div class="club-icon">
          ${icons.mapMarker}
        </div>
        <div class="club-info">
          <div class="club-name">${displayName}</div>
          <div class="club-details">
            ${icons.mapMarker} ${fullAddress}
            ${club.phone ? html`<br>📞 ${club.phone}` : ''}
          </div>
        </div>
        ${this.showMapLinks ? html`
          <div class="club-actions">
            ${club.website ? html`
              <a href="${club.website}" target="_blank" class="club-action-btn" title="Sito web">
                ${icons.externalLink}
              </a>
            ` : ''}
            <button type="button" class="club-action-btn" 
                    @click="${(e: Event) => { e.stopPropagation(); this.openGoogleMaps(fullAddress); }}" 
                    title="Apri in Google Maps">
              ${icons.mapMarkedAlt}
            </button>
          </div>
        ` : ''}
      </div>
    `;
  }

  private renderCityItem(city: CitySearchResult, index: number) {
    const isSelected = index === this.selectedIndex;
    
    return html`
      <div 
        class="padel-result-item ${isSelected ? 'selected' : ''}"
        data-index="${index}"
        @click="${() => this.handleItemClick(city)}"
      >
        <div class="club-icon">
          <i class="fas fa-city"></i>
        </div>
        <div class="club-info">
          <div class="club-name">${city.name}</div>
          <div class="club-details">
            �️ Cerca club in questa città
          </div>
        </div>
      </div>
    `;
  }

  render() {
    return html`
      <div class="padel-club-dropdown ${this.isOpen ? 'show' : ''}">
        ${this.isLoading ? html`
          <div class="loading">
            ${icons.spinner} Ricerca in corso...
          </div>
        ` : ''}
        
        ${!this.isLoading && this.results.length === 0 && this.currentQuery ? html`
          <div class="no-results">
            ${icons.search} ${this.noResultsText}
          </div>
        ` : ''}
        
        ${!this.isLoading && this.results.length > 0 ? html`
          ${this.results.map((item, index) => {
            if (item.type === 'club') {
              return this.renderClubItem(item as ClubSearchResult, index);
            }
            // Skip city items for now - only show clubs
            return '';
          })}
        ` : ''}
        
        ${this.showManualInput && !this.isLoading ? html`
          <div class="manual-input-section">
            <div class="manual-input-title">Non trovi il tuo club?</div>
            <button type="button" class="manual-input-btn" @click="${this.handleManualInput}">
              ${icons.edit} Inserisci manualmente
            </button>
          </div>
        ` : ''}
      </div>
      
      <!-- Selected Club Info -->
      <div class="selected-club-info ${this.showSelectedClub ? 'show' : ''}">
        ${this.selectedClub ? html`
          <div class="selected-club-card">
            <div class="selected-club-details">
              <div class="selected-club-name">${this.selectedClub.name}</div>
              <div class="selected-club-address">
                ${this.selectedClub.address ? html`📍 ${this.selectedClub.address}, ` : ''}
                🏙️ ${this.selectedClub.city}
                ${this.selectedClub.phone ? html` • 📞 ${this.selectedClub.phone}` : ''}
              </div>
            </div>
            <div class="selected-club-actions">
              <a href="${this.generateMapsUrl(this.selectedClub)}" target="_blank" 
                 class="selected-club-btn btn-map" title="Apri in Google Maps">
                ${icons.mapMarkedAlt}
              </a>
              <button type="button" class="selected-club-btn btn-change" 
                      @click="${this.handleChangeClub}" title="Cambia club">
                ${icons.edit}
              </button>
            </div>
          </div>
        ` : ''}
      </div>
    `;
  }
}

// Global initialization function for backward compatibility
declare global {
  interface Window {
    initPadelClubAutocomplete: (selector: string, options?: Partial<PadelClubAutocompleteOptions>) => PmPadelClubAutocomplete[];
  }
}

window.initPadelClubAutocomplete = function(selector: string, options: Partial<PadelClubAutocompleteOptions> = {}): PmPadelClubAutocomplete[] {
  const inputs = document.querySelectorAll(selector);
  return Array.from(inputs).map(input => {
    const container = input.parentElement;
    if (container) {
      const component = document.createElement('pm-padel-club-autocomplete') as PmPadelClubAutocomplete;
      component.selector = selector;
      Object.assign(component, options);
      container.appendChild(component);
      return component;
    }
    return null;
  }).filter(Boolean) as PmPadelClubAutocomplete[];
};